<h2>User Statistics
  @if (selectedStore) {
    <a routerLink="/stores/{{selectedStore.slug}}" class="btn btn-light btn-sm">
      < Back to {{ selectedStore.name }}
    </a>
  }
</h2>
<h3>Monthly user statistics</h3>
<div class="mb-3 monthly-activity">
  @for (activity of monthToUserCountMap | keyvalue: keyDescOrder; track activity) {
    <div class="month month-{{ activity.key }}">
      Month: {{ activity.key }}, users count: {{ activity.value }}
    </div>
  }
</div>

<h3>Weekly / daily user statistics</h3>
<div class="weekly-activity">
  @for (weeklyActivity of weekToUserCountMap | keyvalue: keyDescOrder; track weeklyActivity) {
    <div class="week week-{{ weeklyActivity.key }}">
      <div>
        Week: {{ weeklyActivity.key }}, users count: {{ weeklyActivity.value }}
      </div>
      <div class="daily-activity">
        @for (dailyActivity of weekToDailyUserCountMap.get(weeklyActivity.key) | keyvalue; track dailyActivity) {
          <div
            class="date date-{{ dailyActivity.key }}">
            {{ dailyActivity.key }}: {{ dailyActivity.value }}
          </div>
        }
      </div>
    </div>
  }
</div>
